import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useMarkAsUnreadConversation } from 'modules/ats/hooks/conversations/useMarkAsUnreadConversation'

interface Props {
  conversationId: string
  accessId: string
}

const MarkAsUnreadButtonComponent = ({ conversationId, accessId }: Props) => {
  const { loading, markAsUnreadConversation } = useMarkAsUnreadConversation()

  const onClick = async () => {
    await markAsUnreadConversation({
      id: conversationId,
      accessId: accessId,
    })
  }

  return (
    <Button onClick={onClick} type="secondary" disabled={loading}>
      {i18n.t('ats.messages.marks_as_unread')}
    </Button>
  )
}

export const MarkAsUnreadButton = observer(MarkAsUnreadButtonComponent)
